import { render, staticRenderFns } from "./detailpeserta.vue?vue&type=template&id=618b7ad3&"
import script from "./detailpeserta.vue?vue&type=script&lang=js&"
export * from "./detailpeserta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports